import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,[_c(VCol,[[_c(VFileInput,{attrs:{"accept":".xlsx, .xls, .csv","label":"Select File","outlined":"","show-size":""},on:{"change":_vm.uploadXlsx},model:{value:(_vm.selectXlsx),callback:function ($$v) {_vm.selectXlsx=$$v},expression:"selectXlsx"}})]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }